export enum StorageKey {
    EmailForSignIn = 'emailForSignIn'
}
